<template>
  <div>
    <my-purchases/>
  </div>
</template>

<script>
import myPurchases from '../../../components/user-profile/my_purchases'
export default {
  name: 'MyPurchasesView',
  components: {
    myPurchases
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/user-profile/my_purchases.view.vue